import tiersApi from '@/api/tiers.api'

const module = {
  namespaced: true,

  state: {
    searchResults: [],
    pageNumber: 0,
    pageSize: 20
  },

  getters: {
    searchResults (state) {
      return state.searchResults
    },
    hasMore (state) {
      return state.searchResults.length >= state.pageSize + state.pageSize * state.pageNumber
    },
    pageNumber (state) {
      return state.pageNumber
    },
    pageSize (state) {
      return state.pageSize
    }
  },
  mutations: {
    GET_TIERS (state, searchResults) {
      state.searchResults = searchResults
    },
    UPDATE_PAGE_NUMBER (state, pageNumber) {
      state.pageNumber = pageNumber
    }
  },
  actions: {
    search ({ commit }, { query }) {
      this.pageNumber = 0
      return tiersApi.searchTiers(query, { page: 0, size: 100 }).then(data => {
        commit('GET_TIERS', data)
        return data
      })
    },
    searchMore ({ commit, getters }, { query }) {
      commit('UPDATE_PAGE_NUMBER', getters.pageNumber + 1)
      return tiersApi.searchTiers(query, { page: getters.pageNumber, size: getters.pageSize }).then(data => {
        // On ajoute les nouveaux tiers à ceux equistant
        data = getters.searchResults.concat(data)
        commit('GET_TIERS', data)
        return data
      })
    }
  }

}

export default module
